const FormCalcToggle = (event): void => {
  event.preventDefault()
  event.stopImmediatePropagation()
  if ($formHolder && $calcHolder) {
    $formHolder.hidden = false
    $calcHolder.hidden = true
  }
}

const $submitCalcButton = document.querySelector<HTMLAnchorElement>('[data-calculator-cta]')
const $formHolder = document.querySelector<HTMLElement>('[data-main-form] [data-registration-form]')
const $calcHolder = document.getElementById('kalkulator-przelewow-zagranicznych')

export function handleFormToggle(): void {
  if ($submitCalcButton) {
    $submitCalcButton.addEventListener('click', FormCalcToggle)
  }
}
